export const loginActionTypes = {
    AGREEMENTS_FETCHED: 'AGREEMENTS_FETCHED',
    USER_FOUND: 'USER_FOUND',
    TOGGLE_AGREEMENTS: 'TOGGLE_AGREEMENTS',
    LINK_USER_REQUEST: 'LINK_USER_REQUEST',
    LINK_USER_SUCCESS: 'LINK_USER_SUCCESS',
    LINK_USER_FAILURE: 'LINK_USER_FAILURE',

    GET_MEMBER_REQUEST: 'GET_MEMBER_REQUEST',
    GET_MEMBER_SUCCESS: 'GET_MEMBER_SUCCESS',
    GET_MEMBER_FAILURE: 'GET_MEMBER_FAILURE',

    END_SESSION_REQUEST: 'END_SESSION_REQUEST',

    RESET: 'RESET',
};
